<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">基本资料</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/index/info/safe'}">安全中心</el-breadcrumb-item>
            <el-breadcrumb-item>支付密码</el-breadcrumb-item>
        </el-breadcrumb>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
</style>
